import { combineReducers } from 'redux'

import loginReducer from './reducers/loginReducer'
import signupReducer from './reducers/signupReducer'
import userNotificationsReducer from './reducers/userNotificationsReducer'
import locationReducer from './reducers/locationReducer'
import modaisReducer from './reducers/modaisReducer'
import passwordReducer from './reducers/passwordReducer'
import newsletterReducer from './reducers/newsletterReducer'
import usersReducer from './reducers/usersReducer'
import blogReducer from './reducers/blogReducer'
import tagsReducer from './reducers/tagsReducer'
import clubsReducer from './reducers/clubsReducer'
import eventsReducer from './reducers/eventsReducer'

const reducers = combineReducers({
  login: loginReducer,
  signup: signupReducer,
  userNotification: userNotificationsReducer,
  location: locationReducer,
  modais: modaisReducer,
  password: passwordReducer,
  newsletter: newsletterReducer,
  users: usersReducer,
  blog: blogReducer,
  tags: tagsReducer,
  clubs: clubsReducer,
  events: eventsReducer,
})

export default reducers


// WEBPACK FOOTER //
// ./src/modules/index.js